// Components
import { StepMediaUploadFileSelectComponent } from './step-media-upload-file-select.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_MEDIA_UPLOAD_FILE_SELECT = {
  stepIdentifier: 'mediaUploadFlowStepUploadFileSelect',
  identifier: 'uploadFileSelect',
  component: StepMediaUploadFileSelectComponent,
  name: 'Upload',
  title: 'Upload your media',
  subtitle: 'Add a title and upload the file you want to verify.',
  header: true,
  headerDistinctive: false,
  displayInFlowProgressBar: false,
  canNavigateBack: false,
} as MediaUploadFlowStep;
